<template>
  <div>
    <base-header class="pb-6 pb-8 pt-8 pt-md-5">
      <!-- Card stats -->
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div class="col-xl-12 order-xl-1">
            <card shadow>
              <template #header>
                <div class="border-0">
                  <div class="row align-items-center">
                    <div class="col-8 text-start">
                      <h5 v-if="!isUpdate" class="mb-0">{{ $t("New Partner") }}</h5>
                      <h5 v-else-if="userRole === 'employee'" class="mb-0">{{ $t("Update Profile") }}</h5>
                      <h5 v-else class="mb-0">{{ $t("Update Partner") }}</h5>
                    </div>
                  </div>
                </div>
              </template>
              <form>
                <div class="text-start fw-bolder text-uppercase text-muted">{{ $t("Personal Details") }} </div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.firstName"
                          alternative=""
                          :label="$t('First name')"
                          :placeholder="$t('First name')"
                          input-classes="form-control-alternative"
                          :error="v$.model.firstName.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.lastName"
                          alternative=""
                          :label="$t('Last name')"
                          :placeholder="$t('Last name')"
                          input-classes="form-control-alternative"
                          :error="v$.model.lastName.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.identityCardNumber"
                          alternative=""
                          :label="$t('Identity card number')"
                          :placeholder="$t('Identity card number')"
                          input-classes="form-control-alternative"
                          :error="v$.model.identityCardNumber.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                    <div class="col-lg-6">
                      <base-input
                          v-model="model.registrationNumber"
                          alternative=""
                          :label="$t('Registration number')"
                          :placeholder="$t('Registration number')"
                          input-classes="form-control-alternative"
                          :error="v$.model.registrationNumber.$errors.map( err => { return err.$message })[0]"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div v-if="!isUpdate" class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label float-start">{{ $t("Phone number") }}</label>
                        <base-input
                            v-model="model.phoneNumber"
                            type="number"
                            form-classes="input-group-alternative mb-0 phone-input"
                            style="display: flex;border-radius: 0;"
                            :placeholder="$t('Phone number')"
                            :error="v$.model.phoneNumber.$errors.map( err => { return err.$message })[0]"
                        >
                          <template #addonLeft>
                            <multiselect
                                v-model="model.phoneNumberCode"
                                :options="countryCodes"
                                placeholder=""
                                :show-labels="false"
                                :searchable="true"
                                :custom-label="customLabel"
                                required
                                :multiple="false"
                                class=""
                            >
                              <template #singleLabel="{ option }">
                                <img v-if="option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+option.iso.toUpperCase()+'.png')" />
                                <span class="ps-1" style="line-height: 31px">{{ option.code }}</span>
                              </template>
                              <template #option="props">
                                <img v-if="props.option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+props.option.iso.toUpperCase()+'.png')" />
                                {{ props.option.text }}
                              </template>
                            </multiselect>
                          </template>
                          <template #infoBlock>
                            <span class="text-sm text-muted w-100">{{ $t("Will be used to send verification code for login.") }}</span>
</template>
                        </base-input>
</div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group has-label">
                        <label class="form-control-label">{{ $t("Preferred language") }} </label>
                        <multiselect
                            v-model="model.contactLanguage"
                            :options="['en', 'el']"
                            :placeholder="$t('Select language')"
                            :show-labels="false"
                            required
                            class=""
                        >
                          <template #singleLabel="{ option }">{{ $t(option) }}</template>
                          <template #option="props">
                            {{ $t(props.option) }}
                          </template>
                        </multiselect>
                      </div>
                    </div>
                    <div v-if="userRole === 'system'" class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.type.$error }">
                      <label class="form-control-label">{{ $t("Type") }} </label>
                      <multiselect
                          v-model="model.type"
                          :show-labels="false"
                          :placeholder="$t('Select type')"
                          :options="['doctor', 'nurse', 'physiotherapist']"
>
                        <template #singleLabel="{ option }">{{ $t(option) }}</template>
                        <template #option="props">
                          {{ $t(props.option) }}
                        </template>
                      </multiselect>
                        <div v-if="v$.model.type.$error" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.type.$errors.map( err => { return err.$message })[0] }}
                        </div>
                      </div>
                    </div>
                    <div v-if="userRole === 'system'" class="col-lg-6">
                      <div class="form-group has-label" :class="{'has-danger': v$.model.gender.$error }">
                        <label class="form-control-label">{{ $t("Gender") }} </label>
                        <multiselect
                            v-model="model.gender"
                            :show-labels="false"
                            :placeholder="$t('Select gender')"
                            :options="['male', 'female']"
                        >
                          <template #singleLabel="{ option }">{{ $t(option ?? '') }}</template>
                          <template #option="props">
                            {{ $t(props.option ?? '') }}
                          </template>
                        </multiselect>
                        <div v-if="v$.model.gender.$error" class="text-danger invalid-feedback" style="display: block;">
                          {{ v$.model.gender.$errors.map( err => { return err.$message })[0] }}
                        </div>
                      </div>
                    </div>
                    <div v-if="userRole === 'system'" class="col-lg-6">
                    <div class="form-group has-label">
                      <label class="form-control-label">{{ $t("Status") }} </label>
                      <multiselect
                          v-model="model.status"
                          :show-labels="false"
                          :placeholder="$t('Select status')"
                          :options="statuses"
>
                        <template #singleLabel="{ option }">{{ $t(option) }}</template>
                        <template #option="props">
                          {{ $t(props.option) }}
                        </template>
                      </multiselect>
                    </div>
                  </div>
                    </div>
                </div>
                <div v-if="!isUpdate" class="text-start fw-bolder text-uppercase text-muted">{{ $t("Contact details") }} </div>
                <hr v-if="!isUpdate" class="mt-0">
                <div v-if="!isUpdate" class="ps-lg-4">
                  <div class="row">
                    <base-input
                        v-model="model.email"
                        alternative=""
                        :label="$t('Contact email')"
                        :placeholder="$t('Contact email')"
                        input-classes="form-control-alternative"
                        :error="v$.model.email.$errors.map( err => { return err.$message })[0]"
                    />
                  </div>
                </div>
<!--                <div class="text-start fw-bolder text-uppercase text-muted">{{ $t("Address") }} </div>-->
<!--                <hr class="mt-0">-->
<!--                <div class="ps-lg-4">-->

<!--                  <div class="row">-->
<!--                    <div class="col-md-6">-->
<!--                      <base-input-->
<!--                          v-model="address.street"-->
<!--                          alternative=""-->
<!--                          :label="$t('Street')"-->
<!--                          :placeholder="$t('Home Address')"-->
<!--                          input-classes="form-control-alternative"-->
<!--                      />-->

<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-4">-->
<!--&lt;!&ndash;                      :class="{'has-danger': v$.address.city.$error }"&ndash;&gt;-->
<!--                      <div class="form-group has-label">-->
<!--                        <label class="form-control-label">{{ $t('City') }}</label>-->

<!--                        <multiselect-->
<!--                            v-model="address.city"-->
<!--                            :show-labels="false"-->
<!--                            :deselect-label="$t('Cannot remove this value')"-->
<!--                            :placeholder="$t('Select city')"-->
<!--                            :options="cities"-->
<!--                            :searchable="false"-->
<!--                            :custom-label="customCityLabel"-->
<!--                        >-->
<!--                        </multiselect>-->

<!--&lt;!&ndash;                        <div v-if="v$.address.city.$error" class="text-danger invalid-feedback" style="display: block;">&ndash;&gt;-->
<!--&lt;!&ndash;                          {{ v$.address.city.$errors.map( err => { return err.$message })[0] }}&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="col-lg-4">-->
<!--                      <base-input-->
<!--                          v-model="cyVar"-->
<!--                          disabled="true"-->
<!--                          alternative=""-->
<!--                          :label="$t('Country')"-->
<!--                          :placeholder="$t('Country')"-->
<!--                          input-classes="form-control-alternative"-->
<!--                      />-->
<!--                    </div>-->
<!--                    <div class="col-lg-4">-->
<!--                      <base-input-->
<!--                          v-model="address.postCode"-->
<!--                          alternative=""-->
<!--                          :label="$t('Post code')"-->
<!--                          :placeholder="$t('Post code')"-->
<!--                          input-classes="form-control-alternative"-->
<!--                      />-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
                <template v-if="userRole === 'system'">
                <div class="text-start fw-bolder text-uppercase text-muted">{{ $t("Notes") }} </div>
                <hr class="mt-0">
                <div class="ps-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input alternative="">
                        <textarea
                            v-model="model.description"
                            rows="4"
                            class="form-control form-control-alternative"
                            :placeholder="$t('A few private notes about the partner')"
                        >
                          </textarea>
                      </base-input>
                    </div>
                  </div>
                </div>
              </template>
<!--                <div class="text-start fw-bolder text-uppercase text-muted">Documents </div>-->
<!--                <hr class="mt-0">-->
<!--                <div class="ps-lg-4">-->
<!--                  <div class="row"></div>-->
<!--                </div>-->
                <div class="col-12 text-end">
                  <base-button v-if="!isUpdate" class="me-2" outline type="info" @click="clearForm">{{ $t("Reset") }}</base-button>
                  <submit-button :alert-message="errorMessage" :state="loadingProcess" @clicked="submitEmployee">{{ $t(isUpdate ? 'Update' : 'Submit') }}</submit-button>
                </div>
              </form>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import useVuelidate from "@vuelidate/core"
import {helpers, required, email, requiredIf, minLength, maxLength} from "@vuelidate/validators"
import {getCountryCallingCode, isValidNumber, parsePhoneNumber} from "libphonenumber-js"
import {isoCountryCodeToFlagEmoji, isWindows} from "@/helpers/common"
import SubmitButton from "@/components/SubmitButton.vue"
const isValidPhone = (param) => helpers.withParams(
    { type: "isValidPhone", value: param }, (value) => {

      if (value == null || value === ""){
        return true
      }
      return isValidNumber(param+value)
    })

export default {
  name: "newEmployee",
  components: {SubmitButton},
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      cyVar: "",
      isWindows,
      employeeId: null,
      countryCodes: [],
      isUpdate: false,
      errorMessage: "",
      loadingProcess: "",
      loadingMessage: "",
      statuses: [
        "pending",
        "disabled",
        "active",
      ],
      dbMobilePhone: "",
      cities: ["LIMASSOL", "NICOSIA", "LARNACA", "PAPHOS", "AMOCHOSTOS"],
      // firstName: string;
      // lastName?: string;
      // status: UserStatus;
      // contactLanguage?: Language | null;
      // email?: string | null;
      // phoneNumber: string;
      // type: EmployeeType
      // identityCardNumber: string | null;
      // address: LocationAddress | null,
      // registrationNumber: string | null,
      // medicalSpecialty: string | null
      model: {
        gender: "",
        firstName: "",
        lastName: "",
        status: "active",
        contactLanguage: "en",
        email: "",
        phoneNumber: "",
        phoneNumberCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
        type: "",
        identityCardNumber: "",
        registrationNumber: "",
        medicalSpecialty: "",
      },
      address: {
        countryCode: "CY",
        city: null,
        street: null,
        locality: null,
        postCode: null,
      }
    }
  },
  validations () {
    return {
      model: {
        phoneNumber: {
          requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(!this.isUpdate)),
          validated: helpers.withMessage(this.$t("Must be valid phone number."), isValidPhone(this.model.phoneNumberCode?.code))
        },
        type: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        gender: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        firstName: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        lastName: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        registrationNumber: {
          required: helpers.withMessage(this.$t("Value is required"), required)
        },
        identityCardNumber: {
          required: helpers.withMessage(this.$t("Value is required"), required),
          minLength: minLength(6),
        },
        email: {
          email: email,
          required: helpers.withMessage(this.$t("Value is required"), required)
        }
      },
      // address: {
      //   street: {
      //     required
      //   },
      //   city: {
      //     required
      //   },
      //   countryCode: {
      //     required
      //   },
      //   postCode: {
      //     required,
      //   },
      // },
    }
  },
  computed: {
    userRole(){
      return this.$store.state.user?.claims?.role ?? null
    },
  },
  async mounted() {
    this.cyVar = this.$t("Cyprus")
    if (this.userRole === "system"){
      this.employeeId = this.$route.params.id ?? null
    } else if (this.userRole === "employee"){
      this.employeeId = this.$store.state.user.claims.user_id
    }

    console.log("employeeId", this.employeeId)

    if (this.employeeId !== null) {
      this.isUpdate = true
      await this.getEmployee()
      // await this.getEmployeePrivateInfo()
    }

    let countries = ["CY", "GB", "GR"]

    countries.forEach( country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: this.$t(country) + " +" + code, iso: country})
    })
  },
  methods: {
    isoCountryCodeToFlagEmoji,
    customCityLabel (option) {
      return this.$t(option)
    },
    async getEmployee() {
      const res = await this.$store.dispatch("fetchEmployee", this.employeeId)
      this.model.id = this.employeeId
      this.model.firstName = res.firstName
      this.model.type = res.type
      this.model.gender = res.gender
      this.model.lastName = res.lastName
      this.model.status = res.status
      this.model.email = res.email
      this.model.contactLanguage = res.contactLanguage
      this.address = res.address
      this.model.registrationNumber = res.hasOwnProperty("registrationNumber") ? res.registrationNumber : ""
      this.model.identityCardNumber = res.hasOwnProperty("identityCardNumber") ? res.identityCardNumber : ""
      this.model.bankName = res.bankName

      // this.dbmMobilePhone = res.phoneNumber
      //
      // let phoneDetails = parsePhoneNumber(res.phoneNumber)
      // this.model.phoneNumber = phoneDetails.nationalNumber
      // this.model.phoneNumberCode = {code: phoneDetails.countryCallingCode ?? "+357", text: this.$t(phoneDetails.country ?? "CY") + " " + phoneDetails.countryCallingCode, iso: phoneDetails.country ?? "CY"}
      console.log("model", this.model)
    },
    async getEmployeePrivateInfo(){
      // let res = await this.$store.dispatch("fetchEmployeePrivateInfo", this.employeeId)
      // this.address = res.address
      // this.model.email = res.email
      // this.model.contactLanguage = res.contactLanguage
      // this.model.registrationNumber = res.hasOwnProperty("registrationNumber") ? res.registrationNumber : ""
      // this.model.identityCardNumber = res.hasOwnProperty("identityCardNumber") ? res.identityCardNumber : ""
      // this.model.type = res.type
      // this.model.bankName = res.bankName

      // this.dbmMobilePhone = res.phoneNumber
      // let phoneDetails = parsePhoneNumber(res.phoneNumber)
      // this.model.phoneNumber = phoneDetails.nationalNumber
      // this.model.phoneNumberCode = "+"+phoneDetails.countryCallingCode

    },
    async submitEmployee() {
      let self = this

      this.v$.$touch()

      if (this.v$.model.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      let payload = JSON.parse(JSON.stringify(this.model))

      payload.address = JSON.parse(JSON.stringify(this.address))

      if (payload.type === "doctor") {
        payload.medicalSpecialty = "gp"
      }
      // if (this.isUpdate) {
      //   payload.id = payload.id
      //   delete payload.id
      // }

      payload.phoneNumber = payload.phoneNumberCode.code + payload.phoneNumber
      delete payload.phoneNumberCode

      if (this.dbmMobilePhone === payload.phoneNumber ){
        delete payload.phoneNumber
      }

      delete payload.queries
      delete payload.createdAt
      delete payload.updatedAt
      delete payload.updatedBy
      // console.log("payload", payload)

      this.loadingProcess = "processing"

      console.log("payloaddd emplpoyee", payload)

      FirebaseFunctionsHelper.callFunction(
          this.isUpdate ? "employee-update" : "employee-create",
          payload
      )
          .then((result) => {
            if (result != null && result.hasOwnProperty("message")) {
              self.loadingProcess = "failed"
              self.errorMessage = result.message
              return
            }
            // console.log("submitUser result", result)
            this.loadingProcess = "done"

            if (this.$store.state.user.claims.role === "system") {
            }
            if (!this.isUpdate) {
              this.$router.push({path: "/employees"})
            } else {
              this.$router.push({path: this.$store.state.user.claims.role === "system" ? "/employees/" + self.$route.params.id : "/profile"})
            }
          })
          .catch((error) => {
            self.loadingProcess = "failed"
            self.errorMessage = error.message
            console.log("submitUser error", error)
          })

      // setTimeout(() => {
      //   this.loadingProcess = "failed";
      //   this.loadingMessage = "There was an error.";
      //   //Add Tokens
      // }, 2000);
    },
    clearForm() {
      this.loadingProcess = ""
      if (this.isUpdate){
        this.model = this.dbUser
      } else {
        this.model = {
          phoneNumber: "",
          phoneNumberCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
          firstName: "",
          lastName: "",
          email: "",
          description: "",
          status: "active",
          contactLanguage: "en",
        }

        this.address = {
          countryCode: "CY",
          city: null,
          street: null,
          locality: null,
          postCode: null,
        }
      }
    },
  },
}
</script>
<style scoped>
.form-group.has-label {
  padding-top: 0.5rem !important;
}
</style>
